import React from 'react'
import clsx from 'clsx'

import { TileButtonProps } from './TileButtonProps'
import AppIcon from '../AppIcon/AppIcon'

import { ReactComponent as ArrowIcon } from '../../../icons/svg/arrow-icon.svg'
import './TileButtonStyles.scss'

/**
 * ATOM - Komponent przycisku w formie kafelka
 * 
 * @param {String} heading - Nagłówek  kafelka  
 * @param {String} description - Opis pod nagłówkiem   
 * @param {SVGSVGElement} icon - Ikonka jako komponent React (ReactElement)   
 * @param {Boolean} isRecommended - Czy opcja jest rekomandowana 
 * @param {Function} onClick - Funckja odpalana po naciśnięciu kafelka
 */
const TileButton = (props: TileButtonProps) => {
   const { heading, description, icon, isRecommended, onClick } = props

   return (
      <button className='app-tile-button-outer-wrapper' onClick={onClick}>
         <AppIcon className='app-tile-button-logo-icon' icon={icon} decorative />
         <span className={clsx('app-tile-button-heading', isRecommended && 'app-tile-button-heading--recommended')}>{heading}</span>
         <span className='app-tile-button-description'>{description}</span>
         <AppIcon className='app-tile-button-action-icon' icon={ArrowIcon} decorative color='var(--color-accent-orange-500)' />
      </button>
   )
}

export default TileButton
